import React from "react"
import { Icon } from "components"
import Strings from "utils/strings"
import { SelectedVehicleInfo } from "../types"
import {
	vehiclePanelStyle,
	vehiclePanelCloseStyle,
	vehiclePanelHeaderStyle,
	vehiclePanelIconStyle,
	vehiclePanelRowStyle,
} from "../styles"

interface VehicleInfoPanelProps {
	vehicle: SelectedVehicleInfo
	onClose: () => void
}

const getHeadingDirection = (heading: number): string => {
	const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"]
	const index = Math.round(heading / 45) % 8
	return `${directions[index]} (${Math.round(heading)}°)`
}

const formatDistance = (meters: number): string => {
	return meters >= 1000 ? `${(meters / 1000).toFixed(1)} km` : `${meters} m`
}

const VehicleInfoPanel: React.FC<VehicleInfoPanelProps> = ({
	vehicle,
	onClose,
}) => {
	return (
		<div style={vehiclePanelStyle}>
			<div style={vehiclePanelCloseStyle} onClick={onClose}>
				<Icon name="close" style={{ fontSize: 14, color: "#999" }} />
			</div>
			<div style={vehiclePanelHeaderStyle}>
				<div style={vehiclePanelIconStyle}>
					<Icon name="car" style={{ fontSize: 14, color: "white" }} />
				</div>
				<div>
					<div style={{ fontWeight: 600, fontSize: 14, color: "#333" }}>
						{vehicle.licensePlate}
					</div>
				</div>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: 6,
					fontSize: 12,
				}}
			>
				<div style={vehiclePanelRowStyle}>
					<span style={{ color: "#888" }}>
						{Strings.routes.fleetTracking.speed}
					</span>
					<span style={{ color: "#333", fontWeight: 500 }}>
						{vehicle.speed !== null ? `${vehicle.speed} km/h` : "N/A"}
					</span>
				</div>
				{vehicle.heading !== null && (
					<div style={vehiclePanelRowStyle}>
						<span style={{ color: "#888" }}>
							{Strings.routes.fleetTracking.direction}
						</span>
						<span style={{ color: "#333", fontWeight: 500 }}>
							{getHeadingDirection(vehicle.heading)}
						</span>
					</div>
				)}
				<div style={vehiclePanelRowStyle}>
					<span style={{ color: "#888" }}>
						{Strings.routes.fleetTracking.remainingStops}
					</span>
					<span style={{ color: "#333", fontWeight: 500 }}>
						{vehicle.remainingStops}
					</span>
				</div>
				{vehicle.remainingDistance !== null && (
					<div style={vehiclePanelRowStyle}>
						<span style={{ color: "#888" }}>
							{Strings.routes.fleetTracking.remainingDistance}
						</span>
						<span style={{ color: "#333", fontWeight: 500 }}>
							{formatDistance(vehicle.remainingDistance)}
						</span>
					</div>
				)}
				{vehicle.lastUpdate && (
					<div style={vehiclePanelRowStyle}>
						<span style={{ color: "#888" }}>
							{Strings.routes.fleetTracking.lastUpdate}
						</span>
						<span style={{ color: "#333", fontWeight: 500 }}>
							{vehicle.lastUpdate.toLocaleTimeString("pt-PT", {
								hour: "2-digit",
								minute: "2-digit",
							})}
						</span>
					</div>
				)}
			</div>
		</div>
	)
}

export default VehicleInfoPanel
